import {  Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { arLocale } from "ngx-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
import { EmployeeService } from "src/app/shared/service/employee.service";
import { MonthClosureService } from "src/app/shared/service/month-closure.service";
import { UserService } from "src/app/shared/service/user.service";
import { isNullOrUndefined } from "util";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDatepickerInputEvent,
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
@Component({
  selector: "app-hr-allowances-details",
  templateUrl: "./hr-allowances-details.component.html",
  styleUrls: ["./hr-allowances-details.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HRAllowancesDetailsComponent implements OnInit {
  allowancesDataSource: MatTableDataSource<any>;
  mangerSubmitdDataSource: MatTableDataSource<any>;
  ApproverDataSource: MatTableDataSource<any>;
  allowancesdisplayedColumns: string[] = [
    "NamePerRecords",
    "Status",
    "CreatedBy",
    "email",
    "remove",
  ];
  mangerSubmitdisplayedColumns: string[] = [
    "NamePerRecords",
    "ShiftType",
    "FromDate",
    "EndDate",
    "Amount",
    "ClientId",
    "ProjectId",
    "remove",
  ];
  ApproverdisplayedColumns: string[] = [
    "EmpCode",
    "NamePerRecords",
    "ShiftType",
    "FromDate",
    "EndDate",
    "Amount",
    "ClientId",
    "ProjectId",
  ];
  completedLogDataSource: MatTableDataSource<any>;
  completLogdisplayedColumns: string[] = [
    "NamePerRecords",
    "ShiftType",
    "FromDate",
    "EndDate",
    "Amount",
    "ClientId",
    "ProjectId",
  ];
  error: string;
  employeeDetails: any;
  employeeList: any;
  MangemployeeList: any;
  vendorList = [];
  currentMonth = "";
  currentFY = "";
  clientList = [];
  projectList = [];
  CCEmpCode = "";
  SubmittedCutOffDate = "";
  ApprovalCutOffDate = "";
  ApproverName = "";
  CcList = "";
  ApproverEmpCode = "";
  ApproverList = [];
  InWardList = [];
  isFreeze = true;
  saved = false;
  submited = false;
  IsApproved = false;
  selectedTabIndex: number = 0;
  IsAllowanceFreeze = false;
  IsEmployeeAccess = false;
  showMyAllowance = false;
  showInWard = false;
  showApproved = false;
  completedLog=[];
  @ViewChild("allowancespaginatorAll", { static: true })
  allowancespaginatorAll: MatPaginator;
  @ViewChild("allowancessortAll", { static: true }) allowancessortAll: MatSort;
  @ViewChild("mangerSubmitpaginatorAll", { static: true })
  mangerSubmitpaginatorAll: MatPaginator;
  @ViewChild("mangerSubmitsortAll", { static: true })
  mangerSubmitsortAll: MatSort;
  ApproverpaginatorAll: MatPaginator;
  @ViewChild("approversortAll", { static: true }) approversortAll: MatSort;
  @ViewChild("completesortAll", { static: true }) completesortAll: MatSort;
  minDate: any;
  minDateApporver: any;
  maxDate: any;
  maxDateApporver: any;
  allowNotificationFrom: any;
  submittedEmployeeAllowanceFrom: any;
  completedEmployeeAllowanceFrom: any;
  isReadOnly=false;
  loginName = "";
  selectedMasterIds: any[] = [];
  filteredEmpList: any[] = [];
  MaxItemsList: number = 3;
showNewAddButton=false;
  ApproverRowList=[];
  constructor(
    private _service: MonthClosureService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private allowNotificationFormBuilder: FormBuilder,
    private submittedEmployeeAllowanceFormBuilder: FormBuilder,
    private completedEmployeeAllowanceFormBuilder: FormBuilder,
    public dialog: MatDialog,
  ) {
    this.allowNotificationFrom = this.allowNotificationFormBuilder.group({
      SubmittedCutOffDate: new FormControl(this.SubmittedCutOffDate, [
        Validators.required,  this.dateRangeValidator()
      ]),
      ApprovalCutOffDate: new FormControl(this.ApprovalCutOffDate, [
        Validators.required,  this.dateRangeValidator(),
      ]),
      allowanceNotifyDetails: this.allowNotificationFormBuilder.array([],this.duplicateRowValidator),
    });
    this.submittedEmployeeAllowanceFrom =
      this.submittedEmployeeAllowanceFormBuilder.group({

        // ApproverName: new FormControl(this.ApproverName, [
        //   Validators.required,
        // ]),
        emloyeeAllowanceDetails:
          this.submittedEmployeeAllowanceFormBuilder.array([]),
      });
      this.completedEmployeeAllowanceFrom =
      this.completedEmployeeAllowanceFormBuilder.group({

         completedAllowanceDetails:
          this.completedEmployeeAllowanceFormBuilder.array([]),
      });
    this.allowancesDataSource = new MatTableDataSource();
    this.mangerSubmitdDataSource = new MatTableDataSource();
    this.ApproverDataSource = new MatTableDataSource();
    this.completedLogDataSource = new MatTableDataSource();
  }

  ngOnInit() {
    const today = new Date();
    this.selectedTabIndex = 0;
    // Set the first day of the current month

    this.loginName = this._userService.getEmail();
    this.getClients();
    let permission = this._userService.getApplicationDetails();
    let filterpermission = permission.filter((c) => c.Name == "MonthClose")[0];
    if (filterpermission != null)
    {
      this.IsEmployeeAccess = filterpermission.IsEmployee;
      if(filterpermission.ReadOnlyPermission)
      {
        this.isReadOnly = true;
      }

    }
  }
  dateRangeValidator(): any {
    return (control: any): any | null => {
      const currentValue = new Date(control.value);
      const min = new Date(this.SubmittedCutOffDate);
      const max = new Date(this.ApprovalCutOffDate);

      if (isNaN(currentValue.getTime())) {
        return { invalidDate: 'Invalid date' }; // Handle invalid date input
      }

      if (currentValue < min) {
        return {
           lessThanMin: `Date must be after ${this.SubmittedCutOffDate}`
          };
      }

      if (currentValue > max) {
        return { greaterThanMax: `Date must be before ${this.ApprovalCutOffDate}` };
      }

     if (new Date(this.SubmittedCutOffDate) >= new Date(this.ApprovalCutOffDate)) {
        return { equal: `Equal ${this.ApprovalCutOffDate}` };
      }
      return null; // Valid date
    };
  }

  create() {
    var row = {
      Id:0,
      NamePerRecords: "",
      Status: "Initiated",
      CreatedBy: this._userService.getEmail(),
      email: "",
      remove: "",
    };
    return row;
  }
  createApproverList() {
    var ApproverList=
    {
     Id:0,
     ApproverEmpCode:"",
     ApproverName:"",
     CCEmpCode:"",
     IsApproved:false,
     ApproverId:this.ApproverRowList.length==0?1:+this.ApproverRowList.length+1

    }
    return ApproverList;
  }
  createEmployee(i) {

    var row =
      {
      NamePerRecords: "",
      ShiftType: "",
      FromDate: "",
      EndDate: "",
      Amount: "",
      ClientId: "",
      ProjectName: "",
      remove: "",
      ApproverId:i+1
    };

    return row;
  }
  approverSelectd(event,employeeData) {
    employeeData.ApproverEmpCode = event.option.id;
    var emp = this.employeeDetails.filter(
      (c) => c.EmpCode == event.option.id
    )[0];
    //employeeData.ApproverName = `${emp.NamePerRecords} - ${emp.EmpCode}`;
    employeeData.ApproverName = ` ${emp.EmpCode} - ${emp.NamePerRecords} `;
  }
  ccSelectd(event,employeeData) {
    employeeData.CCEmpCode = event.option.id;
  }
  employeeSelectd(event, row) {
    row.EmpCode = event.option.id;
    var emp = this.employeeDetails.filter(
      (c) => c.EmpCode == event.option.id
    )[0];
    row.EmpName = emp.NamePerRecords;
    row.FY = this.currentFY;
    row.Month = this.currentMonth;

    row.NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
  }
  sendEmail(row: any) {
    row.Month = this.currentMonth;
    // if(this.SubmittedCutOffDate==null ||this.SubmittedCutOffDate=="")
    // {
    //   this.toastr.warning("Cutoff Date is required");
    //   return
    // }
    // if(this.ApprovalCutOffDate==null ||this.ApprovalCutOffDate=="")
    // {
    //   this.toastr.warning("Approver Date is required");
    //   return
    // }
    if (this.allowNotificationFrom.invalid) {
      this.toastr.warning("Please fill in the required fields");
      this.allowNotificationFrom.markAllAsTouched();
      return;
    }
    row.IsEmailSent = true;
    this.allowNotificationFrom.get("SubmittedCutOffDate").disable();
    this.allowNotificationFrom.get("ApprovalCutOffDate").disable();
    var result = [row];
    if (result != null && result.length > 0) {
      for (var i = 0; i < result.length; i++) {
        result[i].FY = this.currentFY;
        result[i].EmpName = this.employeeDetails.filter(
          (c) => c.EmpCode == result[i].EmpCode
        )[0].NamePerRecords;
        result[i].Month = this.currentMonth;
        result[i].SubmittedCutOffDate = this.SubmittedCutOffDate;
        result[i].ApprovalCutOffDate = this.ApprovalCutOffDate;
      }

      result[0].LoginUserName = this._userService.getEmail();
      this._service.saveAllowanceNotication(result).subscribe(
        (data: any[]) => {
          this._service.sendEmailAllowanceHRInitiate(row).subscribe(
            (data: any[]) => {
              this.toastr.success("Saved Successfully, Email Sent");
              this.getAllowancesDetails();
            },
            (error) => (this.error = error)
          );
          //this.toastr.success("Saved Successfully");
        },
        (error) => (this.error = error)
      );
    }
  }
  saveemail() {
    this.saveAllowancessDetails();
  }
  removeNotifyRecordsAt(index: number) {
    const data = this.allowancesDataSource.data;
    data.splice(index, 1);

    this.allowancesDataSource.data = data;
    let validationArray = this.allowNotificationFormBuilder.array([],this.duplicateRowValidator);

    this.allowancesDataSource.data.forEach((detail) => {
      if (detail.IsActive != true)
        validationArray.push(this.createAllowanceNotificationFormGroup(detail));
    });
    this.allowNotificationFrom.setControl(
      "allowanceNotifyDetails",
      validationArray
    );
  }
  doAllowancesManger(element) {
    if (element.NamePerRecords != "") {
      this.employeeList = this.filterEmployee(
        this.employeeDetails,
        element.NamePerRecords
      );
    }
  }
  doAllowancesEmployeeManger(element) {
    if (element.EmpName != "") {
      this.employeeList = this.filterEmployee(
        this.employeeDetails,
        element.NamePerRecords
      );
    }
  }

  doToMangerSearch(mangerName,employeeData) {
    if (!!mangerName &&mangerName != "") {
      this.employeeList = this.filterEmployee(this.employeeDetails, mangerName);
    }
    else{
      employeeData.ApproverEmpCode=null;
       //employeeData.ApproverName = ''
    }
  }

  doCCMangerSearch(mangerName) {
    if (!!mangerName&&mangerName != "") {
      this.employeeList = this.filterEmployee(this.employeeDetails, mangerName);
    }
  }

  filterEmployee(values, NamePerRecords) {
    if(!!values)
    return values.filter((value) =>
      value.NamePerRecords && value.NamePerRecords !== ""
        ? value.NamePerRecords.toLowerCase().includes(
            NamePerRecords.toLowerCase()
          ) || value.EmpCode.toString().includes(NamePerRecords)
        : false
    );
  }

  onChangeCCValues(val,employeeData) {

   // employeeData.CcList = val.map(item => item.NamePerRecords).join(',');
     employeeData.CCEmpCode = val.map(item => item.EmpCode).join(',');
    // if(!!employeeData.CCEmpCode )
    //   {
    //     employeeData.CcList =[];
    //     var array=employeeData.CCEmpCode.split(',')
    //     for(var t=0;t<array.length;t++)
    //     {
    //       var emp = this.employeeDetails.filter(
    //         (c) => c.EmpCode == array[t]
    //       )[0];
    //       if(!!emp)

    //         employeeData.CcList.push(`${emp.EmpCode} - ${emp.NamePerRecords}`);// `${emp.EmpCode} - ${emp.NamePerRecords}`;
    //     }
    //   }

    // console.log("Selected CC Names: ", this.CcList);
    // console.log("Selected CC EmpCodes: ", this.CCEmpCode);
  }

  removeAt(index: number, row: any) {
    const data = this.allowancesDataSource.data;
    if (row.Id > 0) row.IsActive = true;
    else
    { data.splice(index, 1);
      // Remove the control at the specified index

      const items =  this.allowNotificationFrom.get("allowanceNotifyDetails") as FormArray
      items.removeAt(index);

    }

    this.allowancesDataSource.data = data;
  }
  removeCompletedLog(index: number, row: any) {
    const data = this.completedLogDataSource.data;
    if (row.Id > 0) row.IsActive = true;
    else data.splice(index, 1);

    this.completedLogDataSource.data = data;
  }
  removeGroupSubmittedRecord(index: number, row: any) {
    const data = this.ApproverRowList[index];
    if (row.Id > 0)
    {
      const message = "Are you sure you want to delete the record(s)?";
      const dialogData = new ConfirmDialogModel("Confirm Delete", message, "Submit", "OK", "Cancel");
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "500px",
        data: dialogData,
      });
      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult) {
          data.IsActive = true;
          data.LoginUserName = this._userService.getEmail();
          for (var i = 0; i < data.EmployeeAllowancesList.length; i++) {
            data.EmployeeAllowancesList[i].IsActive = true;
          }
          this._service.saveEmployeeAllowance([data]).subscribe(
            (data: any[]) => {
              this.toastr.success("Deleted Successfully");
              this.getEmployeeAllowances();
              //this.getApproverEmployeeList();
              //this.getInWardEmployeeList();
            },
            (error) => (this.error = error)
          );
        }
      });
      }
      else
    {

            this.ApproverRowList.splice(index, 1);
            const items = this.submittedEmployeeAllowanceFrom.get("emloyeeAllowanceDetails") as FormArray;
            // Remove the control at the specified index
            items.removeAt(index);
            this.mangerSubmitdDataSource.data = this.mangerSubmitdDataSource.data.filter(s => s.ApproverId != row.ApproverId);



      }
      // this.mangerSubmitdDataSource.data = data.filter(c=>c.IsActive!=true);;
      // let validationArray = this.submittedEmployeeAllowanceFormBuilder.array([]);
      // this.mangerSubmitdDataSource.data.forEach((detail) => {
      //   validationArray.push(this.createSubmiitedAllowanceFormGroup(detail));
      // });
      // this.submittedEmployeeAllowanceFrom.setControl(
      //   "emloyeeAllowanceDetails",
      //   validationArray
      // );
  }
  removeSubmittedRecord(index: number, row: any,employeeData) {
    const data = this.mangerSubmitdDataSource.data;
    if (row.Id > 0)
    {
         const message = "Are you sure you want to delete the record?";
      const dialogData = new ConfirmDialogModel("Confirm Delete", message, "Submit", "OK", "Cancel");
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "500px",
        data: dialogData,
      });
      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult) {

        row.IsActive = true;
        var result = this.mangerSubmitdDataSource.data.filter(s => s.IsActive==true);
        if (result != null && result.length > 0) {
          // for (var i = 0; i < result.length; i++) {
          //   result[i].IsSubmitted = this.submited;
          //   if (this.submited == true) result[i].IsSaved = true;
          //   else result[i].IsSaved = this.saved;
          //   result[i].ApproverEmpCode = this.ApproverEmpCode;
          //   result[i].To = this.ApproverName;
          //   result[i].CC = this.CcList;
          //   result[i].CCEmpCode = this.CCEmpCode;
          //   result[i].FY = this.currentFY;
          //   result[i].Month = this.currentMonth;
          //   result[i].ApprovalCutOffDate = this.ApprovalCutOffDate;
          //   result[i].AllowanceId = this.allowancesDataSource.data.filter(
          //     (c) => c.EmpCode == this._userService.getEmpCode()
          //   )[0].Id;
          // }

          employeeData.LoginUserName = this._userService.getEmail();
          this._service.saveEmployeeAllowance([employeeData]).subscribe(
            (data: any[]) => {
              this.toastr.success("Deleted Successfully");
              this.getEmployeeAllowances();
              //this.getApproverEmployeeList();
              //this.getInWardEmployeeList();
            },
            (error) => (this.error = error)
          );

          }
        }
      });
      }
    else
    {
    data.splice(index, 1);

    // const items = this.submittedEmployeeAllowanceFrom.get("emloyeeAllowanceDetails")as FormArray;
    // // Remove the control at the specified index
    //  items.removeAt(index);
    }

    this.mangerSubmitdDataSource.data = data.filter(c=>c.IsActive!=true);;
    let validationArray = this.submittedEmployeeAllowanceFormBuilder.array([]);
    this.mangerSubmitdDataSource.data.forEach((detail) => {
      validationArray.push(this.createSubmiitedAllowanceFormGroup(detail));
    });
    this.submittedEmployeeAllowanceFrom.setControl(
      "emloyeeAllowanceDetails",
      validationArray
    );
  }

  addRow() {
    this.allowancesDataSource.data.push(this.create());
    this.allowancesDataSource.filter = "";
    let validationArray = this.allowNotificationFormBuilder.array([],this.duplicateRowValidator);

    this.allowancesDataSource.data.forEach((detail) => {
      validationArray.push(this.createAllowanceNotificationFormGroup(detail));
    });
    this.allowNotificationFrom.setControl(
      "allowanceNotifyDetails",
      validationArray
    );
  }
  addApproverRow()
  {
    this.ApproverRowList.push(this.createApproverList())
  }
  addMangerEmployeeRow(i:any) {

    this.mangerSubmitdDataSource.data.push(this.createEmployee(i));
    this.mangerSubmitdDataSource.filter = "";
    let validationArray = this.submittedEmployeeAllowanceFormBuilder.array([]);

    this.mangerSubmitdDataSource.data.forEach((detail) => {
      validationArray.push(this.createSubmiitedAllowanceFormGroup(detail));
    });
    this.submittedEmployeeAllowanceFrom.setControl(
      "emloyeeAllowanceDetails",
      validationArray
    );
  }
  checkCurrentDate()
  {
    var months = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    var curentMonthDay = months.indexOf(
      this.currentMonth.split("-")[0].toLowerCase()
    );
    if (
      curentMonthDay != new Date().getMonth() ||  parseInt(20 + this.currentMonth.split("-")[1]) != new Date().getFullYear()

    ) {
     var today=new Date()
      this.showNewAddButton = true;
      this.allowNotificationFrom.get("SubmittedCutOffDate").disable();
      this.allowNotificationFrom.get("ApprovalCutOffDate").disable();
      today = new Date(
        parseInt(20 + this.currentMonth.split("-")[1]),
        curentMonthDay,
        today.getDate() ,0
      );
   if(today>new Date())
   {
     this.showNewAddButton = false;
     this.allowNotificationFrom.get("SubmittedCutOffDate").enable();
     this.allowNotificationFrom.get("ApprovalCutOffDate").enable();
   }
    }
  }
  getAllowancesDetails() {
    this.ApprovalCutOffDate = "";
    this.SubmittedCutOffDate = "";

    this._service.getAllowanceNotication(this.currentMonth).subscribe(
      (data: any[]) => {
        this.allowancesDataSource.data = [];
        this.showMyAllowance =false;
        this.showNewAddButton=false;
    this.checkCurrentDate();
        if (data != null && data.length > 0) {
          let validationArray = this.allowNotificationFormBuilder.array([],this.duplicateRowValidator);
          for (var i = 0; i < data.length; i++) {
            var emp = this.employeeDetails.filter(
              (c) => c.EmpCode == data[i].EmpCode
            )[0];
            if(!!emp)
            data[i].NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
            data[i].Status = "Initiated";
            // if (!!data[i].IsApproved && data[i].IsApproved)
            //   data[i].Status = "Approved";
             if (data[i].IsSubmitted && data[i].IsSubmitted)
              data[i].Status = "Submitted";

            validationArray.push(
              this.createAllowanceNotificationFormGroup(data[i])
            );
          }
          this.allowNotificationFrom.setControl(
            "allowanceNotifyDetails",
            validationArray
          );
          this.SubmittedCutOffDate = data[0].SubmittedCutOffDate;
          this.ApprovalCutOffDate = data[0].ApprovalCutOffDate;
          this.allowNotificationFrom.get("SubmittedCutOffDate").disable();
          this.allowNotificationFrom.get("ApprovalCutOffDate").disable();
          let checkAllowanceData = data.filter(
            (c) => c.EmpCode == this._userService.getEmpCode()
          );
          if (checkAllowanceData != null && checkAllowanceData.length > 0) {
            this.showMyAllowance = true;
          }

          this.allowancesDataSource.data = data;

          this.allowancesDataSource.paginator = this.allowancespaginatorAll;
          this.allowancesDataSource.sort = this.allowancessortAll;
          let today=new Date();
          var date = new Date(this.SubmittedCutOffDate);
          var cutOff = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() ,0
          );
          today = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() ,0
          );
          if(today>cutOff)
          {
            this.showNewAddButton = true;;


          }
          //this.getEmployeeAllowances();
          //this.getCompletLogEmployeeAllowances();
          this.getEmployeeAllowances();
          this.getApproverEmployeeList();
          this.getInWardEmployeeList();
          this.getCompletLogEmployeeAllowances();
        }
        else{
          var today=new Date()
          this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()+1);
          this.minDateApporver = new Date(today.getFullYear(), today.getMonth(),today.getDate()+2 );
          // Set the last day of the current month
          this.maxDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          this.maxDateApporver = new Date(
            today.getFullYear(),
            today.getMonth() + 1,
            0
          );
        }
      },
      (error) => (this.error = error)
    );
  }
  changed(row) {
    row.IsUpdated = true;
  }
  saveAllowancessDetails() {
    if (this.allowNotificationFrom.invalid) {
      this.toastr.warning("Please fill in the required fields");
      this.allowNotificationFrom.markAllAsTouched();
      return;
    }
    var result = this.allowancesDataSource.data;
    if (result != null && result.length > 0) {
      for (var i = 0; i < result.length; i++) {
        result[i].FY = this.currentFY;
        result[i].EmpName = this.employeeDetails.filter(
          (c) => c.EmpCode == result[i].EmpCode
        )[0].NamePerRecords;
        result[i].Month = this.currentMonth;
        result[i].SubmittedCutOffDate = this.SubmittedCutOffDate;
        result[i].ApprovalCutOffDate = this.ApprovalCutOffDate;
      }

      result[0].LoginUserName = this._userService.getEmail();
      this._service.saveAllowanceNotication(result).subscribe(
        (data: any[]) => {
          this.toastr.success("Saved Successfully");

        },
        (error) => (this.error = error)
      );
    }
  }
  checkDate()
  {
    var months = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    var curentMonthDay = months.indexOf(
      this.currentMonth.split("-")[0].toLowerCase()
    );
    return curentMonthDay;
  }
  getEmployeeAllowances() {
    this.mangerSubmitdDataSource.data = [];
    this.ApproverRowList=[];
    this._service.getEmployeeAllowances(this.currentMonth).subscribe(
      (data: any[]) => {
        this.mangerSubmitdDataSource.data = [];

        this.ApproverRowList=[]
        let EmployeeList=[];
        this.IsApproved=false;
        // alert(this.checkDate());
        // alert(new Date().getMonth());
        // if (this.checkDate() != new Date().getMonth()) {
        //   this.IsApproved=true;
        // }
        if (data != null && data.length > 0) {

          let validationArray =
            this.submittedEmployeeAllowanceFormBuilder.array([]);


            for(var i=0;i<data.length;i++)
            {
              data[i].ApproverEmpCode=data[i].ApproverCode
              data[i].CCEmpCode=data[i].CCEmpCode
              data[i].CCEmpCode=data[i].CCEmpCode
              data[i].ApproverName = `${ data[i].ApproverCode} - ${ data[i].EmpName}`;;
            this.submited = data[i].IsSubmitted;
            this.saved = data[i].IsSaved;
           // this.IsApproved = data[i].IsApproved;
              let today=new Date();
              var date = new Date(this.SubmittedCutOffDate);
              var firstDay = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()+1 ,0
              );
debugger;
              if(!!data[i].CCEmpCode)
              {
                data[i].CcList =[];
                var array=data[i].CCEmpCode.split(',')
                for(var t=0;t<array.length;t++)
                {
                  var emp = this.employeeDetails.filter(
                    (c) => c.EmpCode == array[t]
                  )[0];
                  if(!!emp)

                    data[i].CcList.push(`${emp.EmpCode} - ${emp.NamePerRecords}`);// `${emp.EmpCode} - ${emp.NamePerRecords}`;
                }
              }

              data[i].ApproverId=i+1
              data[i].IsFreezed = false;
              data[i].Status = "Saved";
              if (!!data[i].IsApproved && data[i].IsApproved && data[i].IsHRRejected!=true && !data[i].IsFreezed )
                data[i].Status = "Approved";
             else if (!!data[i].IsRejected && data[i].IsRejected && !data[i].IsFreezed)
                data[i].Status = "Rejected(Approver)";
            else  if (!!data[i].IsHRRejected && data[i].IsHRRejected && !data[i].IsFreezed)
                data[i].Status = "Rejected(HR)";
            else if (!!data[i].IsSubmitted && data[i].IsSubmitted)
              data[i].Status = "Submitted";
              if (firstDay<=new Date(today.getFullYear(), today.getMonth(), today.getDate(),0)) {
                data[i].IsApproved = true;
                this.IsApproved = true;
                data[i].IsFreezed = true;
              }


              this.ApproverRowList.push(data[i])
              for (var x = 0; x < data[i].EmployeeAllowancesList.length; x++) {
                data[i].EmployeeAllowancesList[x].ApproverId = i + 1

                  var emp = this.employeeDetails.filter(
                    (c) => c.EmpCode == data[i].EmployeeAllowancesList[x].EmpCode
                  )[0];
                  if (!!emp)

                  data[i].EmployeeAllowancesList[x].NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;// `${emp.EmpCode} - ${emp.NamePerRecords}`;
                data[i].EmployeeAllowancesList[x].EmpName =emp.NamePerRecords


                if(  data[i].IsApproved == true)
                {
                  data[i].EmployeeAllowancesList[x].IsApproved=true;
                }

                EmployeeList.push(data[i].EmployeeAllowancesList[x])
                validationArray.push(
                  this.createSubmiitedAllowanceFormGroup(data[i].EmployeeAllowancesList[x])
                );
              }
              this.mangerSubmitdDataSource.data=EmployeeList;
            }
          //this.ApproverList=data;
          //this.ApproverEmpCode = data[0].ApproverEmpCode;
         // this.CCEmpCode = data[0].CCEmpCode;

          // this.ApproverName = data[0].To;
          // this.CcList = data[0].CC;


          this.submittedEmployeeAllowanceFrom.setControl(
            "emloyeeAllowanceDetails",
            validationArray
          );
          //this.mangerSubmitdDataSource.data = data;
          // this.mangerSubmitdDataSource.paginator = this.allowancespaginatorAll;
          // this.mangerSubmitdDataSource.sort = this.allowancessortAll;
        }
        else{
          let today1=new Date();
          var date = new Date(this.SubmittedCutOffDate);
          var cutOff = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() ,0
          );
          today1 = new Date(
            today1.getFullYear(),
            today1.getMonth(),
            today1.getDate() ,0
          );
          if(today1>cutOff)
          {
            this.IsApproved=true;;

          }


        }
      },
      (error) => (this.error = error)
    );
  }
  getApproverEmployeeList() {
    this.ApproverList = [];
    this._service.getApproverEmployeeList(this.currentMonth).subscribe(
      (data: any[]) => {
        this.ApproverList = [];
        this.showApproved=false;
        if (data != null && data.length > 0) {
          data = data.filter((c) => c.Month == this.currentMonth);
          let today=new Date();
          var date = new Date(this.ApprovalCutOffDate);
          var firstDay = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() + 1,0
          );
          let checkApprovedData = data.filter(
            (c) => c.ApproverCode == this._userService.getEmpCode() && c.IsSubmitted==true
          );
          if (checkApprovedData != null && checkApprovedData.length > 0) {
            this.showApproved = true;
          }
          for (var i = 0; i < data.length; i++) {
            if (firstDay <= new Date(today.getFullYear(), today.getMonth(), today.getDate(),0)) {
              data[i].IsFreezed = true;
            }
          }
          this.ApproverList = data;
        }
      },
      (error) => (this.error = error)
    );
  }
  getInWardEmployeeList() {
    this.InWardList = [];
    this._service.getInWardEmployeeList(this.currentMonth).subscribe(
      (data: any[]) => {
        this.InWardList = [];
        this.showInWard =false;
        if (data != null && data.length > 0) {
          data = data.filter((c) => c.Month == this.currentMonth);
          let checkInWardData = data.filter((c) =>
            c.CCEmpCode != null
              ? c.CCEmpCode.includes(this._userService.getEmpCode()) && c.IsSubmitted==true
              : null
          );
          if (checkInWardData != null && checkInWardData.length > 0) {
            this.showInWard = true;
          }
          this.InWardList = data;
        }
      },
      (error) => (this.error = error)
    );
  }
  getCompletLogEmployeeAllowances() {
    this.completedLogDataSource.data = [];
    this.completedLog=[];
    this.IsAllowanceFreeze=false;
    this._service.getCompletLogEmployeeAllowances(this.currentMonth).subscribe(
      (data: any[]) => {
        this.completedLogDataSource.data = [];
        this.completedLog=[];
        this.IsAllowanceFreeze=false;
        if (data != null && data.length > 0) {
        var date = new Date(this.ApprovalCutOffDate);
        var firstDay = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + 2,0
        );
        var today=new Date();
        if (firstDay <= new Date(today.getFullYear(), today.getMonth(), today.getDate(),0)) {
          this.IsAllowanceFreeze = true;
        }
          this.completedLog=data;

        }
      },
      (error) => (this.error = error)
    );
  }
  duplicateRowValidator = (formArray: any): { [key: string]: any } | null => {
    const rows = (formArray as FormArray).controls;
    let values = rows.map(row => row.get('NamePerRecords')!=null ?row.get('NamePerRecords').value:null);

    if(!!values)
    {

    const duplicates = values.filter((value, index) => values.indexOf(value) !== index);

    rows.forEach(row => {
      const valueControl = row.get('NamePerRecords');

        if(valueControl && valueControl.value!="")
        valueControl.setErrors(duplicates.includes(valueControl.value) ? { duplicate: true } : null);
      else{
        //valueControl.setErrors({ required: true });
      }

    });

    return duplicates.length > 0 ? { duplicate: true } : null;
  }
  return null;
  };
  mangerSubmited() {
    this.saved=false;
    this.saveEmployeeAllowance();
  }
  mangerSaved() {
    this.saved = true;
    this.submited = false;
    this.saveEmployeeAllowance();
  }
  saveApprovedRecord(row) {
    var result = this.ApproverList.filter((c) => c.Id == row.Id)[0]
      .EmployeeAllowancesList;
    result[0].LoginUserName = this._userService.getEmail();
    this._service.saveApprovedEmployeeAllowance(result).subscribe(
      (data: any[]) => {
        this.toastr.success("Approved Successfully");
        this.getApproverEmployeeList();
        this.getInWardEmployeeList();
        this.getCompletLogEmployeeAllowances();
      },
      (error) => (this.error = error)
    );
  }
  onAllowanceTabChange(event: any) {
    this.selectedTabIndex =event.index;
    if (event.tab.textLabel=='New') {
      this.getAllowancesDetails();
    }
    if (event.tab.textLabel=='My Allowances') {
      this.getEmployeeAllowances();
    }
    if (event.tab.textLabel=='My Approvals') {
      this.getApproverEmployeeList();
    }
    if (event.tab.textLabel=='Inward') {
      this.getInWardEmployeeList();
    }
    if (event.tab.textLabel=='All Allowances') {
      this.getCompletLogEmployeeAllowances();
    }
  }
  // saveAllEmployeeAllowance() {
  //   if (this.completedEmployeeAllowanceFrom.invalid) {
  //     this.toastr.warning("Please fill in the required fields");
  //     this.completedEmployeeAllowanceFrom.markAllAsTouched();
  //     return;
  //   }
  //   var result = this.completedLogDataSource.data;
  //   if (result != null && result.length > 0) {
  //     for (var i = 0; i < result.length; i++) {
  //       result[i].IsApproved = true;
  //       result[i].IsSubmitted = true;
  //       result[i].IsSaved = true;
  //       result[i].ApproverEmpCode = this.ApproverEmpCode;
  //       result[i].To = this.ApproverName;
  //       result[i].CC = this.CcList;
  //       result[i].CCEmpCode = this.CCEmpCode;
  //       result[i].FY = this.currentFY;
  //       result[i].Month = this.currentMonth;
  //       result[i].ApprovalCutOffDate = this.ApprovalCutOffDate;
  //       result[i].AllowanceId = this.allowancesDataSource.data.filter(
  //         (c) => c.EmpCode == this._userService.getEmpCode()
  //       )[0].Id;
  //     }

  //     result[0].LoginUserName = this._userService.getEmail();
  //     this._service.saveEmployeeAllowance(result).subscribe(
  //       (data: any[]) => {
  //         this.toastr.success("Saved Successfully");
  //         this.getCompletLogEmployeeAllowances();
  //       },
  //       (error) => (this.error = error)
  //     );
  //   }
  // }
  saveEmployeeAllowance() {
    if (this.submittedEmployeeAllowanceFrom.invalid) {
      this.toastr.warning("Please fill in the required fields");
      this.submittedEmployeeAllowanceFrom.markAllAsTouched();
      return;
    }
   var validApprover= this.ApproverRowList.filter(c=>c.ApproverEmpCode==null || c.ApproverEmpCode=="" ||c.ApproverEmpCode==undefined )
   if(!!validApprover&& validApprover.length>0)
   {
    this.toastr.warning("Select Approver");
    //this.submittedEmployeeAllowanceFrom.markAllAsTouched();
    return;
   }
   var validApprover= this.ApproverRowList.filter(c=>c.ApproverEmpCode==null || c.ApproverEmpCode=="" ||c.ApproverEmpCode==undefined )
   if(!!validApprover&& validApprover.length>0)
   {
    this.toastr.warning("Select Approver");
    //this.submittedEmployeeAllowanceFrom.markAllAsTouched();
    return;
   }
   for (var a = 0; a < this.ApproverRowList.length; a++) {
   var objExit= this.mangerSubmitdDataSource.data.filter(c=>c.ApproverId==this.ApproverRowList[a].ApproverId);
    if(!!objExit && objExit.length>0)
    {

    }
    else{
      this.toastr.warning("No records found");
    //this.submittedEmployeeAllowanceFrom.markAllAsTouched();
    return;
    }
   }
    var result = this.mangerSubmitdDataSource.data.filter(c=>c.IsApproved!=true &&c.IsRejected!=true);
    if (result != null && result.length > 0) {

      if(this.saved==false)
      this.submited = true;
      for (var i = 0; i < result.length; i++) {
        result[0].LoginUserName = this._userService.getEmail();
        result[i].IsSubmitted = this.submited;
        if (this.submited == true) result[i].IsSaved = true;
        else result[i].IsSaved = this.saved;
        result[i].ApproverEmpCode =this.ApproverRowList.filter(c=>c.ApproverId==result[i].ApproverId)[0].ApproverEmpCode;
        result[i].To = this.ApproverName;
        result[i].CC = result[i].CcList;
       result[i].CCEmpCode = result[i].CCEmpCode ;// this.ApproverRowList.filter(c=>c.ApproverId==result[i].ApproverId)[0].CCEmpCode;
        result[i].FY = this.currentFY;
        result[i].Month = this.currentMonth;
        result[i].ApprovalCutOffDate = this.ApprovalCutOffDate;
        result[i].IsRejected=false;
        result[i].AllowanceId = this.allowancesDataSource.data.filter(
          (c) => c.EmpCode == this._userService.getEmpCode()
        )[0].Id;
      }

      result[0].LoginUserName = this._userService.getEmail();
      for(var x=0;x<this.ApproverRowList.length;x++)
        {
          this.ApproverRowList[x].ApproverCode=this.ApproverRowList[x].ApproverEmpCode
          this.ApproverRowList[x].CCEmpCode=this.ApproverRowList[x].CCEmpCode
          this.ApproverRowList[x].AllowanceId=this.allowancesDataSource.data.filter(
            (c) => c.EmpCode == this._userService.getEmpCode()
          )[0].Id;

          this.ApproverRowList[x].IsSubmitted = this.submited;
          if (this.submited == true) this.ApproverRowList[x].IsSaved = true;
          else this.ApproverRowList[x].IsSaved = this.saved;
          this.ApproverRowList[x].EmployeeAllowancesList=result.filter(c=>c.ApproverId==this.ApproverRowList[x].ApproverId);
        }
      let request = this.ApproverRowList.filter(c => c.IsApproved != true && c.IsRejected != true && c.IsHRRejected != true)
      request[0].EmployeeAllowancesDuplicateList = this.mangerSubmitdDataSource.data;
      this._service.saveEmployeeAllowance(request).subscribe(
        (data: any[]) => {
          if(data!=null)
          {

            this.mangerSubmitdDataSource.data = data[0].EmployeeAllowancesDuplicateList;
            this.toastr.warning("Record already exists and has been approved.");
          }
          else{


          if (this.submited == true)
            this.toastr.success("Submitted Successfully");
          else this.toastr.success("Saved Successfully");
          this.getEmployeeAllowances();
       }
         // this.getApproverEmployeeList();
         // this.getInWardEmployeeList();
        },
        (error) => (this.error = error)
      );
    }
    else{
      this.toastr.warning("No records to submit")
    }
  }
  onRowClick(row: any) {
    row.IsDuplicate = false;
  }
  getClients() {
    this._service.getClients().subscribe(
      (data: any[]) => {
        this.clientList = data;
      },
      (error) => (this.error = error)
    );
  }
  porjectChanged(row) {
    row.ProjectName = row.projectList.filter(
      (value) => value.ProjectID == row.ProjectId
    )[0].ProjectName;
  }
  getProjects(row) {
    row.ClientName = this.clientList.filter(
      (value) => value.ClientId == row.ClientId
    )[0].ClientName;
    this._service.getProjects(row.ClientId).subscribe(
      (data: any[]) => {
        row.projectList = data;
      },
      (error) => (this.error = error)
    );
  }
  rejectHR(row: any) {
    var result = { ...row };
    const dialogData = new ConfirmDialogModel(
      "Reject",
      "Rejection Comments",
      "Manager"
    );
    var dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult.event) {
          result.EmployeeAllowancesList[0].RejectedReason = dialogResult.data;
          result.EmployeeAllowancesList[0].LoginUserName = this.loginName;
          //result = [result];
          this._service.saveHRRejectedEmployeeAllowance(result.EmployeeAllowancesList).subscribe(
            (data: any[]) => {
              this.toastr.success("Rejected Successfully");
              this.getCompletLogEmployeeAllowances();
              //this.getInWardEmployeeList();
            },
            (error) => (this.error = error)
          );
        }
      },
      (error) => {
        error;
      }
    );
  }
  reject(row: any) {
    var result = { ...row };
    const dialogData = new ConfirmDialogModel(
      "Reject",
      "Rejection Comments",
      "Manager"
    );
    var dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult.event) {
          result.EmployeeAllowancesList[0].RejectedReason = dialogResult.data;
          result.EmployeeAllowancesList[0].LoginUserName = this.loginName;
          //result = [result];
          this._service.saveRejectedEmployeeAllowance(result.EmployeeAllowancesList).subscribe(
            (data: any[]) => {
              this.toastr.success("Rejected Successfully");
              this.getApproverEmployeeList();
              this.getInWardEmployeeList();
            },
            (error) => (this.error = error)
          );
        }
      },
      (error) => {
        error;
      }
    );
  }
  setDate(event: any): any {
    const selectedDate = event.value;
    if (selectedDate) {
      const d = new Date(selectedDate);
      return new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes() - d.getTimezoneOffset()
      ).toISOString();
    }
    return "";
  }

  SubmittedCutOffDateDateChanged(event: MatDatepickerInputEvent<Date>) {
    this.SubmittedCutOffDate = this.setDate(event);
  }
  ApprovalCutOffDateDateChanged(event: MatDatepickerInputEvent<Date>) {
    this.ApprovalCutOffDate = this.setDate(event);
  }
  FromDateChanged(row, event: MatDatepickerInputEvent<Date>) {
    row.FromDate = this.setDate(event);
  }
  EndDateChanged(row, event: MatDatepickerInputEvent<Date>) {
    row.EndDate = this.setDate(event);
  }
  private createAllowanceNotificationFormGroup(item: any): FormGroup {
    return new FormGroup({
      NamePerRecords: new FormControl(item.NamePerRecords, [
        Validators.required,
      ]),
    });
  }
  private createCompletedAllowanceFormGroup(item: any): FormGroup {
    return new FormGroup({

      NamePerRecords: new FormControl(item.NamePerRecords, [
        Validators.required,
      ]),
      ShiftType: new FormControl(item.ShiftType, [
        Validators.required,
      ]),
      FromDate: new FormControl(item.FromDate, [
        Validators.required,
      ]),
      EndDate: new FormControl(item.EndDate, [
        Validators.required,
      ]),
      Amount: new FormControl(item.Amount, [ Validators.required,
        Validators.pattern("^\\d{1,12}?$"),
      ]),
    });
  }
  private createSubmiitedAllowanceFormGroup(item: any): FormGroup {
    let approved=false;
    if(item.IsApproved)
    approved=true;
    if(item.IsRejected)
      approved=true;
    return new FormGroup({

      NamePerRecords: new FormControl( { value: item.NamePerRecords, disabled: approved
      } , [
        Validators.required,
      ]),
      ShiftType: new FormControl({ value: item.ShiftType, disabled: approved
      } , [
        Validators.required
      ]),
      FromDate: new FormControl({ value: item.FromDate, disabled: approved
      } , [
        Validators.required,  this.dateShiftRangeValidator(item),
      ]),
      EndDate: new FormControl({ value: item.EndDate, disabled: approved
      } , [
        Validators.required,,  this.dateShiftRangeValidator(item),
      ]),
      Amount: new FormControl({ value: item.Amount, disabled: approved
      } ,[ Validators.required,
        Validators.pattern("(?!0$)\\d{1,12}?$"),
      ]),
    });
  }
  dateShiftRangeValidator(item): any {
    return (control: any,item:any): any | null => {

      const currentValue = new Date(control.value);
    //   const min = new Date(this.SubmittedCutOffDate);
    //   const max = new Date(this.ApprovalCutOffDate);
   if (isNaN(currentValue.getTime())) {
        return { invalidDate: 'Invalid date' }; // Handle invalid date input
      }
     if(!!control.parent&& control.parent.value.FromDate!="" &&control.parent.value.EndDate!="")
      {
        //let today1=new Date();
        var from = new Date(control.parent.value.FromDate);
        var to = new Date(control.parent.value.EndDate)
        from=new Date(from.getFullYear(),
        from.getMonth(),
        from.getDate() ,0
        );
        to = new Date(
          to.getFullYear(),
          to.getMonth(),
          to.getDate() ,0
        );
        if(from>to)
        {
          return {
            lessThanMin: `Date must be after ${control.parent.value.FromDate}`
           }

        }
        else{
          control.parent.controls.EndDate.setErrors(null)
          control.parent.controls.FromDate.setErrors(null)
        }



      }


    //   if (currentValue < min) {
    //     return {
    //        lessThanMin: `Date must be after ${this.SubmittedCutOffDate}`
    //       };
    //   }

    //   if (currentValue > max) {
    //     return { greaterThanMax: `Date must be before ${this.ApprovalCutOffDate}` };
    //   }
    //
    //  if (new Date(this.SubmittedCutOffDate) >= new Date(this.ApprovalCutOffDate)) {
    //     return { equal: `Equal ${this.ApprovalCutOffDate}` };
    //   }
      return null; // Valid date
    };
  }
}
